import angular from 'angular'
import 'url-search-params-polyfill'

import '../controller/controller'

export const Parse = {
  encode: (object) => Object.entries(object || {})
    .reduce((params, [key, value]) => {params.append(key, value); return params}, new URLSearchParams())
    .toString(),

  decode: (string) => Object.fromEntries(new URLSearchParams(string).entries())
}
export default Parse

angular.module("core.application.main").factory("core.application.main.factory.parse", [() => Parse])
